import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { isEmpty } from 'lodash';
import { ProjectEdit } from 'app/models';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private api: string;
  private httpOptions: any;
  private storage = localStorage;
  private s3: string;
  private env: string;
  private version: string;

  // Allow UI components to subscribe to project logo updates
  private projectLogoUpdated = new Subject<number>();
  public readonly projectLogoUpdated$ = this.projectLogoUpdated.asObservable();

  constructor(private http: HttpClient) {
    this.api = environment.api_url;
    this.env = environment.production
      ? '/itdatabase-media/'
      : '/itdatabase-media/Development/';
    this.s3 = `${environment.s3_url}${this.env}`;
    this.version = 'v1';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public getProjects(): Observable<any> {
    return this.http.get(
      `${this.api}/projects/list`,
      this.httpOptions
    );
  }

  // public getTopicsOfProjects(projectId): Observable<any> {
  //   return this.http.get(
  //     `${this.api}/project/v2/${projectId}/topics`,
  //     this.httpOptions
  //   );
  // }

  public save(
    newProjectName: string,
    shared: boolean
  ): Observable<any> {
    const name = encodeURIComponent(newProjectName);
    return this.http.post(
      `${this.api}/projects/create?newProjectName=${name}&shared=${shared}`,
      null,
      this.httpOptions
    );
  }

  public update(project: ProjectEdit): Observable<any> {
    return this.http.patch(
      `${this.api}/projects/${project.projectId}`,
      project,
      this.httpOptions
    );
  }

  public transfer(projectId: number, accountId: number, userId: number): Observable<any> {
    return this.http.patch(
      `${this.api}/projects/${projectId}`,
      { userId, accountId },
      this.httpOptions
    );
  }

  public delete(projectId: number): Observable<any> {
    return this.http.delete(
      `${this.api}/projects/${projectId}`,
      this.httpOptions
    );
  }

  public getProject() {
    const project = this.storage.getItem('project');
    return isEmpty(project) ? null : JSON.parse(project);
  }

  public saveProjec(project) {
    this.storage.setItem('project', JSON.stringify(project));
  }

  public getProjectLogo(projectId: number, forceRefresh: boolean): string {
    let url = `${this.s3}projects/${this.version}/${projectId}.png`;
    if (forceRefresh) {
      url += `?${new Date().getTime()}`;
    }
    return url;
  }

  public uploadProjectLogo(projectId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId.toString());

    return this.http
      .post(`${this.api}/projects/${projectId}/logo`, formData)
      .pipe(tap(() => this.projectLogoUpdated.next(projectId)));
  }

  public exportProjectToExcel(projectId: number): Observable<Blob> {
    return this.http.post(
      `${this.api}/project/${projectId}/export`,
      {},
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        observe: 'body',
      }
    );
  }
}
